import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL || 'http://localhost:8080/api',
  timeout: 180000,
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
})

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ut')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      config.headers['ut'] = token
      config.headers['userName'] = localStorage.getItem('userName')
    }

    return config
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

export default request
